import { mapState } from "vuex";
import { consoleWarn } from "@/assets/js/Renderer/renderFns";

export default {
    computed: {
        ...mapState("components", ["properties", "live", "components"])
    },
    methods: {
        getGenericsAndPropertiesByGuid(guid) {
            const properties = this.properties[guid];
            if (!properties) {
                consoleWarn(`Properties not found for ${guid}.`);
                return { properties: null, generics: null };
            }

            const { __generics: generics = null } = properties;
            return { properties, generics };
        }
    }
};
